<template>
  <v-app>
    <v-main>
      <rec-alert
        :set-dialog="this.alertDialog"
        @close="closeAlert"
        @cancel="cancelAlert"
      ></rec-alert>
      <router-view></router-view>
    </v-main>
    <progress-bar
      :set-loading="this.progress"
      @showLoading="showLoading"
      @hideLoading="hideLoading"
    ></progress-bar>
    <CommonDialog />
  </v-app>
</template>

<script>
import RecAlert from '@/components/common/RecAlert';
import StatusCircular from '@/components/items/StatusCircular.vue';
import CommonDialog from '@/plugins/dialog/Dialog.vue';
import { langStorage } from './plugins/locales';
export default {
  name: 'App',
  components: {
    'progress-bar': StatusCircular,
    RecAlert,
    CommonDialog,
  },
  data() {
    return {
      alertDialog: {
        dialog: false,
        message: '',
        title: '',
        okBtn: '확인',
        cancelBtn: '취소',
        cancel: false,
        param: null,
      },
      progress: {
        loading: false,
      },
    };
  },
  watch: {
    '$i18n.locale'(lang) {
      langStorage.set(lang);
      this.$router.push({ name: 'ReRender' });
    },
  },

  methods: {
    showLoading() {
      this.progress = { loading: true };
    },
    hideLoading() {
      this.progress = { loading: false };
    },
    showAlert(v) {
      this.alertDialog = this.clone(this.alertDialog, v);
      if (!v.hasOwnProperty('cancel') || v['cancel'] == null) {
        this.alertDialog['cancel'] = null;
      }

      if (!v.hasOwnProperty('callback') || v['callback'] == null) {
        this.alertDialog['callback'] = null;
      }
    },
    cancelAlert() {
      if (
        this.alertDialog.hasOwnProperty('cancel') &&
        this.alertDialog.cancel
      ) {
        this.alertDialog.callback = null;
      }
      if (this.alertDialog.hasOwnProperty('cancelCallback')) {
        if (this.alertDialog.cancelCallback instanceof Function) {
          this.alertDialog.cancelCallback(this.alertDialog.param);
        } else this.alertDialog.cancelCallback = null;
      }
      this.closeAlert();
    },
    closeAlert() {
      this.alertDialog.dialog = false;
      if (this.alertDialog.hasOwnProperty('callback')) {
        if (this.alertDialog.callback instanceof Function) {
          this.alertDialog.callback(this.alertDialog.param);
        } else this.alertDialog.callback = null;
      }
    },
    clone(v1, v2) {
      if (v2 === null || typeof v2 !== 'object') return v2;
      for (var attr in v2) {
        if (v2.hasOwnProperty(attr)) {
          v1[attr] = v2[attr];
        }
      }
      return v1;
    },
  },
};
</script>
